import API from '@/api';

class Geocoder {
  toAddressString(locationObj) {
    var addressStr = '';
    if (locationObj) {
      addressStr += locationObj.address_line_1
        ? locationObj.address_line_1 + ' '
        : '';
      addressStr += locationObj.address_line_2
        ? locationObj.address_line_2 + ' '
        : '';
      addressStr += locationObj.city ? locationObj.city + ', ' : '';
      if (locationObj.province || locationObj.postal_code) {
        addressStr += locationObj.province ? locationObj.province + ', ' : '';
        addressStr += locationObj.postal_code
          ? locationObj.postal_code + ', '
          : '';
      } else {
        addressStr += locationObj.state ? locationObj.state + ', ' : '';
        addressStr += locationObj.zip_code ? locationObj.zip_code + ', ' : '';
      }
      addressStr += locationObj.country ? locationObj.country : '';
    }
    return addressStr;
  }

  requestLocationObj(locationObj) {
    let address = this.toAddressString(locationObj);
    return API.post('geocode', { address });
  }

  request(address) {
    return API.post('geocode', { address });
  }
}

export default new Geocoder();
